var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contact)?_c('ContactDetails',{attrs:{"contact":_vm.contact}}):_c('v-col',[_c('p',{staticClass:"text-red-500"},[_vm._v(" "+_vm._s(_vm.$t('errors.contact_not_found'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }